// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"0203f380","379":"3b09dc2b","662":"e4a3f7d9","757":"5a38db09"}[chunkId] + ".css";
};